import React, { useState } from 'react';

import { useFormik } from 'formik';
import _ from 'lodash';
import { useDispatch } from 'react-redux';

import { userUpdateProfile } from 'api/endpoints/user-management';
import Button from 'components/Button';
import ErrorMessage from 'components/ErrorMessage';
import Input from 'components/Input';
import { MESSAGE_COMMON, MESSAGE_PROFILE } from 'constants/string/messages';
import { TEXT_COMMON, TEXT_PROFILE, TEXT_USER_LIST } from 'constants/string/texts';
import { toastError, toastSuccess } from 'lib/toast';
import { setLoading } from 'store/actions/common';
import { getCodeJapaneseGovernmentsWith, getJapaneseGovernments } from 'utils/helper';

const UpdateProfile = ({ data, back, reload }) => {
  const dispatch = useDispatch();
  const japanese_government = getJapaneseGovernments() || [];
  const [isSubmitted, setIsSubmitted] = useState(false);

  const initialValues = {
    municipality: data.municipality || '',
  };

  const handleUpdateUser = async (values) => {
    try {
      dispatch(setLoading({ isOpen: true }));
      await userUpdateProfile(data.id, {
        ...values,
        department: data?.department || '',
        municipality: getCodeJapaneseGovernmentsWith(values.municipality, true) || '',
      })
        .then(async (response) => {
          toastSuccess(response.message || '');
          back();
        })
        .catch((errors) => {
          toastError(errors.message);
        });
      dispatch(setLoading({ isOpen: false }));
    } catch {
      dispatch(setLoading({ isOpen: false }));
    } finally {
      reload();
    }
  };

  const form = useFormik({
    initialValues: initialValues,
    validateOnChange: isSubmitted,
    validateOnBlur: false,
    validate: (values) => {
      const errors = {};
      if (!values.municipality) {
        errors.municipality = true;
      } else {
        const japanese_government = getJapaneseGovernments() || [];
        const governmentExits = _.findIndex(japanese_government, (item) => _.some(item.options, { value: values.municipality }));
        if (governmentExits === -1) {
          errors.municipality = true;
        }
      }
      setIsSubmitted(true);
      return errors;
    },
    onSubmit: async (values) => {
      await handleUpdateUser(values);
    },
  });

  return (
    <>
      <div className="flex-between-center px-6 py-4 border-b border-white-720">
        <p className="font-bold">{TEXT_USER_LIST.LOCAL_GOVERNMENT_EDITTING}</p>
      </div>

      <div className="p-6">
        <fieldset>
          <p className="text-black/85 mb-2 flex items-center">
            <span className="text-danger-411 mr-1">
              <img src={require('assets/resources/Required.svg').default} alt="required" width={7} height={7} />
            </span>
            {TEXT_PROFILE.MUNICIPALITY}
          </p>
          <Input
            onSelect={(e) => {
              form.setFieldValue('municipality', e);
            }}
            value={form.values.municipality}
            onChange={(e) => {
              form.setFieldValue('municipality', e);
            }}
            name="municipality"
            classNameInput="!h-10"
            className="w-full"
            type="autocomplete"
            options={japanese_government}
            filterOption={(inputValue, option) =>
              option.value &&
              (option.value.toUpperCase().indexOf(inputValue.toUpperCase()) !== -1 ||
                option.code.toUpperCase().indexOf(inputValue.toUpperCase()) !== -1)
            }
            invalid={form.errors?.municipality}
          />
          <p className={`text-sm ${form.errors.municipality ? 'text-danger-229 h-5.75' : 'text-secondary-354'}`}>
            {form.values.municipality && form.errors.municipality && <ErrorMessage>{MESSAGE_PROFILE.GOVERNMENT_INCORRECT}</ErrorMessage>}
            {!form.values.municipality && form.errors?.municipality && <ErrorMessage>{MESSAGE_COMMON.NOT_EMPTY}</ErrorMessage>}
          </p>
          {!form.errors.municipality && <p className="text-sm text-secondary-354 h-5.75">{TEXT_PROFILE.MUNICIPALITY_REQUIRED}</p>}
        </fieldset>
      </div>

      <div className="h-16 border-t border-white-720 flex-end-center gap-2 py-4 px-6">
        <Button className="h-8 text-sm" text={TEXT_COMMON.CANCEL_TEXT} color="outline" onClick={back} />
        <Button className="h-8 text-sm" text={TEXT_COMMON.RENEW} color="primary" onClick={form.handleSubmit} />
      </div>
    </>
  );
};

export default React.memo(UpdateProfile);
